import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes.js";
import { getToken } from "utils/authStorage";

export default function Auth() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = "ltr";
  if (getToken()) {
    return <Navigate to="/admin/header" replace />;
  }
  return (
    <div className="flex justify-center items-center h-screen w-full">
      <Routes>
        {getRoutes(routes)}
        <Route
          path="/"
          element={<Navigate to="/auth/sign-in" replace />}
        />
      </Routes>
    </div>
  );
}
